/**
 * User-ID de GA4 para el dataLayer (VEX-6458).
 *
 * Dos reglas que no son obvias:
 *
 * 1. Se resuelve en CADA push. El plugin lo resolvia una sola vez, al cargarse,
 *    cuando todavia no hay usuario autenticado: el id quedaba en `undefined`
 *    para toda la vida de la pagina.
 * 2. Viaja como texto. GA4 trata User-ID como string; un entero se serializa sin
 *    comillas y no matchea con el que manda el Measurement Protocol del back.
 */

// `login`, `sign_up` e `identify` (store/auth.js) empujan su evento ANTES del
// commit SET_USER, asi que en ese momento el store todavia no tiene al usuario:
// para esos eventos el unico dato disponible es el del propio payload.
const userFromPayload = (payload) => payload && payload.auth && payload.auth.user;

const idOf = (user) => {
  if (!user) {
    return undefined;
  }
  const { id } = user;
  if (id === undefined || id === null || id === '') {
    return undefined;
  }
  return String(id);
};

export const resolveUserId = (storeUser, payload) =>
  idOf(storeUser) || idOf(userFromPayload(payload));

export default resolveUserId;
